(function () {
  'use strict';

  var page = document.querySelector('[data-bonsai-page]');

  if (!page) {
    return;
  }

  var nav = page.querySelector('[data-bonsai-nav]');

  if (!nav) {
    return;
  }

  var navShell = nav.querySelector('.bonsai-quick-nav__shell');

  if (!navShell) {
    return;
  }

  var linkItems = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'))
    .map(function (link) {
      var id = (link.getAttribute('href') || '').slice(1);
      var section = id ? document.getElementById(id) : null;

      if (!id || !section) {
        return null;
      }

      return {
        id: id,
        link: link,
        section: section,
      };
    })
    .filter(Boolean);

  if (!linkItems.length) {
    return;
  }

  var ticking = false;
  var navCueTicking = false;
  var currentId = '';
  var initialHashHandled = false;

  function getHeaderOffset() {
    var fixedHeader = document.querySelector('.site-header');
    var fixedHeaderHeight = fixedHeader ? fixedHeader.getBoundingClientRect().height : 0;
    var navHeight = nav.getBoundingClientRect().height || 0;

    return fixedHeaderHeight + navHeight + 20;
  }

  function setActive(id) {
    if (!id || id === currentId) {
      return;
    }

    currentId = id;

    linkItems.forEach(function (item) {
      if (item.id === id) {
        item.link.setAttribute('aria-current', 'true');
      } else {
        item.link.removeAttribute('aria-current');
      }
    });
  }

  function getCurrentSectionId() {
    var offset = getHeaderOffset();
    var active = linkItems[0].id;

    linkItems.forEach(function (item) {
      if (item.section.getBoundingClientRect().top - offset <= 18) {
        active = item.id;
      }
    });

    return active;
  }

  function updateActiveLink() {
    ticking = false;
    setActive(getCurrentSectionId());
  }

  function requestActiveUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateActiveLink);
  }

  function updateNavScrollCue() {
    navCueTicking = false;

    var hasOverflow = navShell.scrollWidth - navShell.clientWidth > 4;
    var isAtEnd =
      !hasOverflow || navShell.scrollLeft + navShell.clientWidth >= navShell.scrollWidth - 4;

    if (hasOverflow && !isAtEnd) {
      nav.setAttribute('data-show-scroll-cue', 'true');
    } else {
      nav.removeAttribute('data-show-scroll-cue');
    }
  }

  function requestNavCueUpdate() {
    if (navCueTicking) {
      return;
    }

    navCueTicking = true;
    window.requestAnimationFrame(updateNavScrollCue);
  }

  function scrollToSection(id, smooth) {
    var target = document.getElementById(id);

    if (!target) {
      return;
    }

    var top = window.scrollY + target.getBoundingClientRect().top - getHeaderOffset();

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: smooth ? 'smooth' : 'auto',
    });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + id);
    } else {
      window.location.hash = id;
    }

    setActive(id);
  }

  linkItems.forEach(function (item) {
    item.link.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToSection(item.id, true);
    });
  });

  window.addEventListener('scroll', requestActiveUpdate, { passive: true });
  navShell.addEventListener('scroll', requestNavCueUpdate, { passive: true });
  window.addEventListener('resize', function () {
    requestActiveUpdate();
    requestNavCueUpdate();
  });
  requestActiveUpdate();
  requestNavCueUpdate();

  if (window.location.hash) {
    var initialId = window.location.hash.slice(1);
    var hasMatch = linkItems.some(function (item) {
      return item.id === initialId;
    });

    if (hasMatch) {
      window.addEventListener('load', function () {
        if (initialHashHandled) {
          return;
        }

        initialHashHandled = true;
        window.setTimeout(function () {
          scrollToSection(initialId, false);
          requestNavCueUpdate();
        }, 40);
      });
    } else {
      window.addEventListener('load', requestNavCueUpdate);
    }
  } else {
    window.addEventListener('load', requestNavCueUpdate);
  }
})();
